import { customAlphabet } from 'nanoid';

// Excludes 0, l, I, O
const alphabet = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ';

// Returns a clean unique string that's 22 characters long.
// Clean means only unambiguous numbers and unambiguous lowercase and uppercase letters.
// There are 58^22 possible values, which is greater than the number of unique UUID values (2^122).
export const cleanId = customAlphabet(alphabet, 22);

export const cleanIdPattern = /^[1-9a-zA-Z]{22}$/;

export const isCleanId = (id: string): boolean => cleanIdPattern.test(id);

export const cleanTinyId = customAlphabet(alphabet, 6);
